import React from 'react';
import { useBrowserLayoutEffect } from '@/hooks';
import { NODE_ID_KEYS } from '@/constants';
import { Body } from './Body';
import styles from './Header.module.scss';

// Types
export interface IProps {
	action?: {
		goBackCallback?: () => void;
		icon: 'logo' | 'xmas-logo' | 'full-logo' | 'back' | 'close' | 'none';
	};
	title?: string;
	showCenterLogo?: boolean;
	showMenuButton?: boolean;
	classes?: {
		headerWithMenu?: string;
		headerIsSticky?: string;
		header?: string;
		container?: string;
		body?: string;
	};
	style?: React.CSSProperties;
}

export const Header = React.memo((props: IProps) => {
	// Destructuring
	const { header, container, headerWithMenu, headerIsSticky } =
		props.classes ?? {};
	const { style } = props ?? {};
	// States
	const [sticky, setSticky] = React.useState(false);
	const [menuIsOpened, setMenuIsOpened] = React.useState(false);

	// Helpers
	const updateHeader = React.useCallback((isShown: boolean) => {
		setMenuIsOpened(isShown);
	}, []);

	// Effects
	useBrowserLayoutEffect(() => {
		const handleScroll = () => {
			setSticky(window.scrollY > 0);
		};

		window.removeEventListener('scroll', handleScroll);
		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	const bodyProps = React.useMemo(() => {
		if (props.action?.icon === 'back') {
			return { ...props, action: undefined };
		}
		return props;
	}, [props]);

	return (
		<div
			id={NODE_ID_KEYS.HEADER}
			className={`
				${styles['header']}
				${header ?? ''}
				${sticky ? `${styles['header_sticky']} ${headerIsSticky}` : ''}
				${menuIsOpened ? `${styles['header_menu-is-open']} ${headerWithMenu}` : ''}
			`}
			style={style}
		>
			<div
				className={`
						container
						${styles['header__container']}
						${container ?? ''}
					`}
			>
				<Body {...bodyProps} updateHeader={updateHeader} />
			</div>
		</div>
	);
});
